import { useEffect, useRef } from "react";
import { loadGoogleMaps, parsePlace, attachAutocomplete, detachAutocomplete } from "@/lib/googleMaps";

const BASE = "flex w-full rounded-none border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

// A text input wired to Google Places Autocomplete (restricted to India by default).
// Falls back to a plain controlled text input when Maps is unavailable.
// onSelect receives { formatted_address, city, state, country, pincode, lat, lng }.
export function PlacesAutocomplete({
  value,
  onChange,
  onSelect,
  placeholder,
  id,
  className = "",
  disabled,
  testid,
  country = "in",
  type = "text",
  autoFocus,
}) {
  const ref = useRef(null);
  const acRef = useRef(null);

  useEffect(() => {
    let active = true;
    loadGoogleMaps()
      .then(() => {
        if (!active || !ref.current || acRef.current) return;
        acRef.current = attachAutocomplete(ref.current, (place) => {
          const parsed = parsePlace(place);
          if (onChange) onChange(parsed.formatted_address || (ref.current ? ref.current.value : ""));
          if (onSelect) onSelect(parsed);
        }, { country });
      })
      .catch(() => {}); // no key / load failure -> plain text input (manual fallback)
    return () => { active = false; detachAutocomplete(acRef.current); acRef.current = null; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <input
      ref={ref}
      id={id}
      type={type}
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      autoFocus={autoFocus}
      data-testid={testid}
      autoComplete="off"
      className={`${BASE} ${className}`}
    />
  );
}

export default PlacesAutocomplete;
